import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/admin/render-a-lot-of-dom',
            name: 'admin-render-a-lot-of-dom',
            component: () => import(/* webpackChunkName: "page-admin-default-render-a-lot-of-dom" */ `./index.vue`),
            meta: {
                enable_keep_alive: false,

                data_for_admin_layout: {
                    data_for_history_tag: {
                        entity: {
                            name: "渲染大量dom",
                        }
                    },
                    data_for_breadcrumb: {
                        entity_list: [
                            {
                                name: "示例功能"
                            },
                            {
                                name: "渲染大量dom"
                            }
                        ]
                    }
                }
            },

        }
    ],
};
